import React from 'react'
import OcrIndex from '../features/ocr'

console.log("OCRPage.jsx");

function OCRPage() {
  return (
    <OcrIndex />
  )
}

export default OCRPage